import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, Circle, ChevronDown, X, PartyPopper } from "lucide-react";
import api from "../../lib/api";
import { openOnboarding } from "./EmptyState";

const STEPS = [
  ["has_property", "Créer votre premier bien", "1 min", () => openOnboarding(1)],
  ["has_tenant", "Ajouter votre locataire", "1 min", (nav) => nav("/app/locataires")],
  ["has_lease", "Créer le bail", "2 min", (nav) => nav("/app/locations")],
  ["has_receipt", "Générer votre première quittance", "30 s", (nav) => nav("/app/quittances")],
  ["has_sent", "L'envoyer à votre locataire", "30 s", (nav) => nav("/app/quittances")],
];

export const OnboardingChecklist = ({ onHide }) => {
  const nav = useNavigate();
  const [s, setS] = useState(null);
  const [open, setOpen] = useState(true);
  useEffect(() => {
    const load = () => api.get("/onboarding/state").then((r) => setS(r.data)).catch(() => {});
    load();
    window.addEventListener("onboarding-closed", load);
    return () => window.removeEventListener("onboarding-closed", load);
  }, []);
  useEffect(() => {
    // Ancienne fermeture (croix) : migrée vers la personnalisation du tableau de bord.
    if (s?.checklist_dismissed && onHide) { onHide(); api.put("/onboarding/wizard", { checklist_dismissed: false }).catch(() => {}); setS({ ...s, checklist_dismissed: false }); }
  }, [s, onHide]);
  if (!s || s.checklist_dismissed || s.has_example) return null;
  const done = STEPS.filter(([k]) => s[k]).length;
  const dismiss = () => { if (onHide) return onHide(); api.put("/onboarding/wizard", { checklist_dismissed: true }).catch(() => {}); setS({ ...s, checklist_dismissed: true }); };
  if (done === STEPS.length) return (
    <div className="flex items-center gap-3 bg-brand-lime/20 border border-brand-lime rounded-2xl px-5 py-4" data-testid="checklist-done">
      <PartyPopper className="w-6 h-6 text-brand-limeDark" />
      <p className="flex-1 text-sm text-brand-greenDeep"><b>Bravo, votre gestion est en place !</b> Vos quittances et relances peuvent maintenant s'automatiser.</p>
      <button onClick={dismiss} className="text-brand-green/50 hover:text-brand-greenDeep" data-testid="checklist-dismiss"><X className="w-5 h-5" /></button>
    </div>
  );
  return (
    <div className="bg-white border border-brand-soft rounded-2xl" data-testid="onboarding-checklist">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center gap-4 px-5 py-4 text-left" data-testid="checklist-toggle">
        <div className="flex-1">
          <p className="font-semibold text-brand-greenDeep">Bien démarrer · {done}/{STEPS.length}</p>
          <div className="mt-2 h-1.5 bg-brand-soft rounded-full overflow-hidden"><div className="h-full bg-brand-limeDark transition-all" style={{ width: `${(done / STEPS.length) * 100}%` }} /></div>
        </div>
        <ChevronDown className={`w-5 h-5 text-brand-green/50 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ul className="px-5 pb-4 space-y-1">
          {STEPS.map(([k, label, time, go], i) => (
            <li key={k}>
              <button disabled={s[k]} onClick={() => go(nav)} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-left text-sm ${s[k] ? "text-brand-green/40" : "hover:bg-brand-softer text-brand-greenDeep"}`} data-testid={`checklist-step-${i + 1}`}>
                {s[k] ? <CheckCircle2 className="w-5 h-5 text-brand-limeDark" /> : <Circle className="w-5 h-5 text-brand-green/30" />}
                <span className={`flex-1 ${s[k] ? "line-through" : "font-medium"}`}>{label}</span>
                {!s[k] && <span className="text-xs text-brand-green/40">{time}</span>}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
